var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('add-to-cart-button',{attrs:{"data":{
    class: 'btn-primary',
    stockCode: _vm.product.stockCode,
    netSuiteId: _vm.product.netSuiteId,
    netSuiteParentId: _vm.product.netSuiteParentId,
    productId: _vm.product.productId,
    quantity: _vm.product.quantity,
    hideCartButton: _vm.product.hideCartButton,
    isAlwaysInStock: _vm.product.isAlwaysInStock,
},"items":_vm.product.components,"netsuite_url":_vm.netsuite_url,"netsuite_app_url":_vm.netsuite_app_url}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }